import React, { useState, useRef, useMemo } from "react"
import styles from "./sliderBanner.module.scss"
import ReactSwipe from "react-swipe"

const Dots = ({ slides, current, onClick }) => {
  return (
    <React.Fragment>
      {slides.map((_item, i) => (
        <div
          key={i}
          className={
            current === i ? `${styles.dot} ${styles.active}` : styles.dot
          }
          onClick={() => onClick(i)}
        />
      ))}
    </React.Fragment>
  )
}

const Arrows = ({ onPrev, onNext }) => {
  return (
    <div className={styles.arrows_wrapper}>
      <div className={styles.leftArrow} onClick={() => onPrev()} />
      <div className={styles.rightArrow} onClick={() => onNext()} />
    </div>
  )
}

const SliderBanner = ({ slides, sliderClass }) => {
  const [position, setPosition] = useState(0)
  const reactSwipe = useRef(null)
  const swipe = useMemo(() => {
    const swipeOptions = {
      speed: 300,
      auto: 4000,
      continuous: true,
      widthOfSiblingSlidePreview: 0,
      callback: index => {
        setPosition(index % slides.length)
      },
    }

    const adjusted = slides

    if (!slides.length) {
      return null
    }

    return (
      <ReactSwipe
        ref={el => {
          reactSwipe.current = el
        }}
        swipeOptions={swipeOptions}
      >
        {adjusted.map(item => item)}
      </ReactSwipe>
    )
  }, [slides])

  const handleChange = id => {
    reactSwipe.current.slide(id)
  }

  const prev = () => {
    reactSwipe.current.prev()
  }

  const next = () => {
    reactSwipe.current.next()
  }

  const classSlider = sliderClass || styles.sliderbanner_wrapper_default

  return (
    <div className={`${styles.sliderbanner_wrapper} ${classSlider}`}>
      {swipe}
      {slides.length > 1 && <Arrows onPrev={prev} onNext={next} />}
      {slides.length > 1 && (
        <div className={styles.dots}>
          <Dots current={position} slides={slides} onClick={handleChange} />
        </div>
      )}
    </div>
  )
}

export default SliderBanner
